// Factory para manejar diferentes tipos de modales de usuarios externos
import React from 'react';
import ComponentExternoEngastadorModal from '../../components/Asignaciones/ComponentExternoEngastadorModal.js';
import ComponentExternoEngastadorBulkModal from '../../components/Asignaciones/ComponentExternoEngastadorBulkModal.js';

// Registry de tipos de externos y sus componentes
const EXTERNO_MODAL_REGISTRY = {
  'EXTERNO_Engastador': {
    component: ComponentExternoEngastadorModal,
    bulkComponent: ComponentExternoEngastadorBulkModal,
    displayName: 'Engastador Externo',
    priority: 1
  },
  // Futuros tipos se pueden agregar aquí fácilmente:
  // 'EXTERNO_Pulidor': {
  //   component: null,
  //   importPath: '../components/ComponentExternoPulidorModal.js',
  //   displayName: 'Pulidor Externo',
  //   priority: 2
  // },
  // 'EXTERNO_Calidad': {
  //   component: null,
  //   importPath: '../components/ComponentExternoCalidadModal.js',
  //   displayName: 'Calidad Externa',
  //   priority: 3
  // }
};

// Función para detectar el tipo de externo basado en el nombre de usuario
export const detectExternoType = (userName) => {
  if (!userName || typeof userName !== 'string') return null;
  
  // Buscar en el registry el tipo que coincida con el prefijo del usuario
  for (const [type, config] of Object.entries(EXTERNO_MODAL_REGISTRY)) {
    if (userName.startsWith(type)) {
      return type;
    }
  }
  
  return null;
};

// Función para obtener la configuración de un tipo de externo
export const getExternoConfig = (type) => {
  return EXTERNO_MODAL_REGISTRY[type] || null;
};

// Función para obtener el componente del modal
export const loadExternoModal = (type) => {
  const config = getExternoConfig(type);
  if (!config) return null;
  
  return config.component;
};

// Función para obtener el componente del modal bulk
export const loadExternoBulkModal = (type) => {
  const config = getExternoConfig(type);
  if (!config) return null;
  
  return config.bulkComponent;
};

// Función principal para crear el modal apropiado
export const createExternoModal = (userName, moData, onClose, onAssign) => {
  const externoType = detectExternoType(userName);
  
  if (!externoType) {
    console.warn(`No se encontró tipo de externo para usuario: ${userName}`);
    return null;
  }
  
  const ModalComponent = loadExternoModal(externoType);
  
  if (!ModalComponent) {
    console.error(`No se pudo cargar el modal para tipo: ${externoType}`);
    return null;
  }
  
  return {
    component: ModalComponent,
    type: externoType,
    props: {
      moData,
      userName,
      onClose,
      onAssign,
      externoType
    }
  };
};

// Función para crear el modal bulk apropiado
export const createExternoBulkModal = (userName, moDataList, onClose, onAssign) => {
  const externoType = detectExternoType(userName);
  
  if (!externoType) {
    console.warn(`No se encontró tipo de externo para usuario: ${userName}`);
    return null;
  }
  
  const BulkModalComponent = loadExternoBulkModal(externoType);
  
  if (!BulkModalComponent) {
    console.error(`No se pudo cargar el modal bulk para tipo: ${externoType}`);
    return null;
  }
  
  return {
    component: BulkModalComponent,
    type: externoType,
    props: {
      moDataList,
      userName,
      onClose,
      onAssign,
      externoType
    }
  };
};

// Función para obtener todos los tipos de externos disponibles
export const getAvailableExternoTypes = () => {
  return Object.keys(EXTERNO_MODAL_REGISTRY);
};

// Función para registrar un nuevo tipo de externo (para futuras extensiones)
export const registerExternoType = (type, config) => {
  if (EXTERNO_MODAL_REGISTRY[type]) {
    console.warn(`El tipo de externo ${type} ya está registrado`);
    return false;
  }
  
  EXTERNO_MODAL_REGISTRY[type] = {
    component: null,
    ...config
  };
  
  return true;
};
